import * as React from "react";
import { withRouter } from "react-router-dom";
import { Col, FormGroup, Input, Label } from "reactstrap";
import nameof from "ts-nameof.macro";
import { ColegiosDropDown } from "../colegios/ColegiosDropDown";
import { CustomDatePicker } from "../helpers/CustomDatePicker";
import { RouteHelper } from "../IntranetRouter";
import { OrigenPedido, PedidosTiendaSearch, PedidoTiendaListItem, PedidoTiendaListItemPaginatedList, SortDirection, TipoUsuario } from "../models/dataModels";
import { IServiceForIndex } from "../utils/base/BaseServices";
import { IndexPageBase, TableColumn } from "../utils/base/IndexPageBase";
import { ClientContext } from "../utils/ClientContext";
import { I18n } from "../utils/I18n";
import { toCamelCase } from "../utils/ValuesFormatter";
import { PedidosTiendaService } from "../pedidosTienda/PedidosTiendaService";


interface PedidosColegioSearchEx extends PedidosTiendaSearch {
    colegio: string;
}

class IndexComp extends IndexPageBase<PedidosColegioSearchEx, PedidoTiendaListItemPaginatedList, PedidoTiendaListItem>
{

    protected _getInitialSearchParams(): PedidosColegioSearchEx {

        let model = super._getInitialSearchParams();
        model.orderMode = SortDirection.Desc;
        model.colegioId = ClientContext.Current.colegioId;
        model.colegio = ClientContext.Current.nombreColegio;
        model.origen = OrigenPedido.Colegio;
        return model;
    }

    protected _getApiService(): IServiceForIndex<PedidosTiendaSearch, PedidoTiendaListItemPaginatedList> {
        return new PedidosTiendaService();
    }


    protected _enableExcelExport() {
        return true;
    }

    protected _renderSearchForm(): React.ReactNode {

        if (this.props.isEmbedded) {
            return null;
        }

        return <React.Fragment>

            <Col xs="12" md="6" lg="3">
                <FormGroup>

                    <ColegiosDropDown
                        label={I18n.Strings.colegio.entityName}

                        onChanged={(colegioId, colegioNombre) => {

                            var state = this._cloneStateForSetState();
                            state.searchParams.colegioId = colegioId;
                            state.searchParams.colegio = colegioNombre;
                            this.setState(state);
                        }}
                        id={nameof(this.state.searchParams.colegioId)}
                        selectedItemValue={this.state.searchParams.colegioId || 0}
                        selectedItemText={this.state.searchParams.colegio || ""}
                        emptyText=""
                    />
                </FormGroup>
            </Col>
            <Col xs="12" md="6" lg="3">
                <FormGroup>
                    <Label for={nameof(this.state.searchParams.nombre)}>
                        {I18n.Strings.pedidosColegio.nombre}
                    </Label>
                    <Input
                        onChange={(evt) => {
                            var state = this._cloneStateForSetState();
                            state.searchParams.nombre = evt.target.value;
                            this.setState(state);
                        }}
                        placeholder={I18n.Strings.pedidosColegio.nombre + "..."}
                        type="text"
                        maxLength={100}
                        className={"form-control"}
                        name={nameof(this.state.searchParams.nombre)}
                        id={"usuarios" + nameof(this.state.searchParams.nombre)}
                        value={this.state.searchParams.nombre || ""}
                    />
                </FormGroup>
            </Col>
            <Col xs="12" md="6" lg="3">
                <FormGroup>
                    <Label for={nameof(this.state.searchParams.fechaPresupuestoFrom)}>
                        {I18n.Strings.pedidosColegio.fechaPresupuestoFrom}
                    </Label>
                    <CustomDatePicker
                        key={nameof(this.state.searchParams.fechaPresupuestoFrom)}
                        value={this.state.searchParams.fechaPresupuestoFrom}
                        yearsFront={2}
                        yearsBack={3}
                        onChange={(val) => {
                            var state = this._cloneStateForSetState();
                            state.searchParams.fechaPresupuestoFrom = val;
                            this.setState(state, () => this._performSearch());
                        }}
                    />
                </FormGroup>
            </Col>

            <Col xs="12" md="6" lg="3">
                <FormGroup>
                    <Label for={nameof(this.state.searchParams.fechaPresupuestoTo)}>
                        {I18n.Strings.pedidosColegio.fechaPresupuestoTo}
                    </Label>
                    <CustomDatePicker
                        key={nameof(this.state.searchParams.fechaPresupuestoTo)}
                        value={this.state.searchParams.fechaPresupuestoTo}
                        yearsFront={2}
                        yearsBack={3}
                        onChange={(val) => {
                            var state = this._cloneStateForSetState();
                            state.searchParams.fechaPresupuestoTo = val;
                            this.setState(state, () => this._performSearch());
                        }}
                    />
                </FormGroup>
            </Col>

        </React.Fragment>;
    }



    protected _getTableColumns(): TableColumn<PedidoTiendaListItem>[] {

        let columns = [];

        columns.push({
            fieldName: nameof(this.state.searchResults.items[0].nombre),
            title: I18n.Strings.pedidosColegio.nombre,
            renderField: (item: PedidoTiendaListItem) => item.nombre
        });

        columns.push({
            fieldName: nameof(this.state.searchResults.items[0].fechaPresupuesto),
            title: I18n.Strings.pedidosColegio.fechaPresupuesto,
            renderField: (item: PedidoTiendaListItem) => I18n.Strings.formatDate(item.fechaPresupuesto)
        });

        columns.push({
            fieldName: nameof(this.state.searchResults.items[0].numItems),
            title: I18n.Strings.pedidosColegio.numUnidades,
            renderField: (item: PedidoTiendaListItem) => I18n.Strings.formatNumber(item.numItems)
        });

        if (
            ClientContext.Current.tipoUsuario == TipoUsuario.AdminGlobal ||
            ClientContext.Current.tipoUsuario == TipoUsuario.AdminInstitucion ||
            ClientContext.Current.tipoUsuario == TipoUsuario.VisorPedidos
        ) {
            columns.unshift({
                fieldName: nameof(this.state.searchResults.items[0].colegio),
                title: toCamelCase(I18n.Strings.colegio.entityName),
                renderField: (item) => item.colegio
            });
        }
        return columns;
    }


    protected _getPageTitle(): string {
        return I18n.Strings.pedidosColegio.title;
    }
    protected _getPageDescription(): string {
        return I18n.Strings.pedidosColegio.description;
    }

    protected _getNewItemUrl(): string {
        return null;
    }

    protected _getEditionItemUrl(item: PedidoTiendaListItem): string {
        return RouteHelper.detallePedidoColegio(item.id);
    }

}

export const Index = withRouter(IndexComp);
